export default __webpack_public_path__ + "static/media/hht2_home_img_EP17.15749e28.png";